import { ZoomControl } from "@shared/common/components/ZoomControl";
import { ButtonGroup } from "@shared/EDS/components/ButtonGroup";
import { useZoomStore } from "@shared/common/contexts/zoomLevel/useSbdZoom";
import {
  LEFT_WIDTH,
  RIGHT_WIDTH,
  TIMELINE_PADDING,
  TIMELINE_DEFAULT_HOUR_WIDTH,
  SCROLL_BAR_WIDTH,
} from "@opstel/SBD/core/layoutConstants";
import { Interval } from "luxon";
import { useCallback, useRef } from "react";
import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";

interface TopBarProps {
  readonly openFilterSidePanel: () => void;
}

function getZoomToFitZoomLevel(interval: Interval, availableWidth: number) {
  const totalHours = interval.toDuration().as("hours");
  const hourWidth =
    (availableWidth - SCROLL_BAR_WIDTH - (LEFT_WIDTH + RIGHT_WIDTH + 2 * TIMELINE_PADDING)) /
    totalHours;
  return hourWidth / TIMELINE_DEFAULT_HOUR_WIDTH;
}

export function SBDTopBar({ openFilterSidePanel }: TopBarProps) {
  const scenarioInterval = useSelectedTimeStore((state) => state.scenarioInterval)!;

  const zoomLevel = useZoomStore((state) => state.zoomLevel);
  const setZoomLevel = useZoomStore((state) => state.setZoomLevel);
  const ref = useRef<HTMLDivElement>(null);

  const handleZoomToFit = useCallback(() => {
    if (!ref.current) return;
    const { width } = ref.current.getBoundingClientRect();
    setZoomLevel(getZoomToFitZoomLevel(scenarioInterval, width));
  }, [scenarioInterval, setZoomLevel]);

  const handleSetZoomLevel = useCallback(
    (value?: number) => {
      if (value) {
        setZoomLevel(value);
      }
    },
    [setZoomLevel],
  );

  return (
    <div
      ref={ref}
      className="absolute top-0 right-0 order-1 flex w-full flex-row items-center justify-end gap-m bg-transparent p-4"
    >
      <ZoomControl
        value={zoomLevel}
        zoomToFit={handleZoomToFit}
        setZoomLevel={handleSetZoomLevel}
      />
      <ButtonGroup data-testid="button-group">
        <tractie-button
          role="button"
          level="tertiary"
          onClick={openFilterSidePanel}
          icon-only={true}
        >
          <tractie-icon name="filter" />
          Open filtermenu
        </tractie-button>
      </ButtonGroup>
    </div>
  );
}
